import React, { useEffect, useState } from "react";
import logo from "../assets/logo.svg";
import googleIcon from "../assets/Google icon.svg";
import { Link, useNavigate } from "react-router-dom";
import axiosInstance from "../axios/axios";
import Loader from "./Loader";
import { FiEye, FiEyeOff } from "react-icons/fi"; // Import eye icons
import ErrorMessage from "./ErrorMessage";
// import VerificationModal from "./VerificationModal";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  // const [showModal, setShowModal] = useState(false);
  const [showPassword, setShowPassword] = useState(false); // Toggle password visibility
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    //clear the local storage
    localStorage.clear();

    // const user = localStorage.getItem("userRole");
    // setUserRole(user || "");
  }, []);

  const handleEmail = (e) => {
    setEmail(e.target.value);
    setError("");
  };

  const handlePassword = (e) => {
    setPassword(e.target.value);
    setError("");
  };

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email || !password) {
      setError("Email and password are required.");
      return;
    }

    try {
      setIsLoading(true);

      const { data } = await axiosInstance.post("/login", { email, password });
      console.log(data);
      // Store authentication details in localStorage
      localStorage.setItem("authToken", data.token);
      localStorage.setItem("userRole", data.role);
      localStorage.setItem("user_id", data.user_id);
      localStorage.setItem("role_specific_id", data.role_specific_id);
      // Role-based navigation
      if (data.role === "admin") {
        navigate("/admindashboard"); // Redirect admin users to admin dashboard
      } else if (data.role === "organization") {
        if (data.verified === 0) {
          // setShowModal(true); // Show modal for unverified users
          window.location.href = "/unverified-company";
        } else {
          navigate("/dashboard/jobs"); // Redirect verified organization users
        }
      } else {
        navigate("/dashboard/jobs"); // Redirect other roles (e.g., job seekers)
      }
    } catch (err) {
      console.error("Login error:", err.status);
      if (err.status === 403) {
        //ON the dashboard page   display a modal that informs the user that their organization is pending approval."
        window.location.href = "/unverified-company";
        console.log("/dashboard");
        // setShowModal(true);
      } else {
        setError(err.response?.data?.error || "An unexpected error occurred.");
      }
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) return <Loader />;

  return (
    <div className="flex items-center justify-center min-h-screen h-full custom-bg flex-col w-100 py-4">
      <div className="form-container w-fit bg-white md:px-[121px] px-[32px] xsm:m-2 xsm:max-m-[32px] py-[48px]">
        <img src={logo} className="mb-[24px]" alt="Logo" />
        <span className="custom-title mb-[14px]">Login</span>
        <span className="custom-desc mb-[24px] max-w-[360px]">
          Welcome back! Please enter your details
        </span>
        <form className="w-full" onSubmit={handleSubmit}>
          <section className="flex-col gap-[20px] flex">
            <div className="flex flex-col w-full">
              <label htmlFor="Email" className="form-label">
                Email
              </label>
              <input
                type="email"
                value={email}
                onChange={handleEmail}
                className="custom-form"
                placeholder="Enter your email"
              />
            </div>
            <div className="flex flex-col w-full relative">
              <label htmlFor="Password" className="form-label">
                Password
              </label>
              <div className="relative">
                <input
                  type={showPassword ? "text" : "password"}
                  value={password}
                  onChange={handlePassword}
                  className="custom-form w-full" // Add padding to prevent overlap with icon
                  placeholder="Enter your password"
                />
                <button
                  type="button"
                  className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500"
                  onClick={togglePasswordVisibility}
                >
                  {showPassword ? <FiEye size={20} /> : <FiEyeOff size={20} />}
                </button>
              </div>
            </div>
            <Link
              to="/reset"
              className="custom-forgot items-end justify-end flex"
            >
              Forgot Password
            </Link>
          </section>
          {error && <ErrorMessage message={error} />}
          {/* {showModal && (
            <VerificationModal
              showModal={showModal}
              setShowModal={setShowModal}
            />
          )} */}
          <button
            type="submit"
            className={`btn bg-[#049645] hover:bg-[#1E4929] w-full font-bold text-lg text-white my-[24px] ${
              isLoading ? "opacity-50 cursor-not-allowed" : "btn btn-secondary"
            }`}
            disabled={isLoading}
          >
            {isLoading ? "Signing in..." : "Sign in"}
          </button>
          <button className="w-full flex items-center justify-center gap-2 border p-2 border-[#D0D5DD] rounded-[8px]">
            <img src={googleIcon} alt="Google Icon" />
            <span>Sign in with Google</span>
          </button>
        </form>
        <section className="flex gap-1 items-center justify-center my-4">
          <span>Do not have an account?</span>
          <Link to="/register" className="custom-forgot">
            Signup
          </Link>
        </section>
      </div>
    </div>
  );
};

export default Login;
